import { createAsyncThunk } from "@reduxjs/toolkit";
import Auth from "ts/api/auth";
import { apiV2 } from "api/firebase";
import { setObservabilityContext } from "tools/observability";

export const fetchUser = createAsyncThunk<Auth>(
  "auth/fetchAndSetupUser",
  async () => {
    const me = await apiV2.user.getMe();

    if (!me) {
      throw new Error("User has no uid, or email, or role");
    }

    // Tag the current Datadog + OpenReplay session with the user's role so
    // sessions can be filtered by audience (organiser vs supplier vs admin).
    // Impersonation fields are passed as `null` (not omitted) when absent
    // so returning to a normal session clears any stale impersonation tag
    // from a prior session in the same tab.
    setObservabilityContext({
      role: me.role,
      impersonatedByEmail: me.impersonatedByEmail ?? null,
      impersonatedByRole: me.impersonatedByRole ?? null,
    });

    return {
      id: me.id,
      email: me.email,
      role: me.role,
      hasPassword: me.lastSetPasTime !== null,
      impersonatedByEmail: me.impersonatedByEmail,
      impersonatedByRole: me.impersonatedByRole,
      returnTokenExpiresAt: me.returnTokenExpiresAt,
    };
  }
);
